<template>

    <Model :is-open="late_fee_history_model">
        <template #body>
            <div class="flex-grow">
                <div class="flex justify-between ">
                    <p class="text-lg font-medium ">Late Fee history</p>
                </div>
                <Table
                    :fields="[
                {'key': 'paid_at', 'label': 'Paid At'},
                {'key': 'late_fee', 'label': 'Late Fee'},
                { 'key': 'discount', 'label': 'Discount' },
                {'key': 'amount', 'label': 'Total Amount'},
                ]"
                    :items="item?.late_fees??[]"
                    :canView="true"
                >
                    <template #late_fee="{item}">₹{{ item.late_fee }}</template>
                    <template #discount="{item}">₹{{ item.discount }}</template>
                    <template #amount="{item}">₹{{ item.amount }}</template>
                </Table>
            </div>
        </template>
        <template #buttons>
            <div class="flex justify-end">
                <Button @click="late_fee_history_model=false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white">Close
                </Button>
            </div>
        </template>
    </Model>
    <!--    handleConfirmPaymentModel-->
    <Model :is-open="delete_confirm_model">
        <template #body>
            <div class="flex-grow">
                <div class="flex justify-between ">
                    <p class="text-lg font-medium ">Are your sure delete the EMI?</p>
                </div>
            </div>
        </template>
        <template #buttons>
            <div class="flex justify-end">
                <Button @click="delete_confirm_model=false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4">Cancel
                </Button>
                <Button @click="handleRemoveEMI(item,item.index)" class="mr-2">Delete</Button>
            </div>
        </template>
    </Model>

    <Model :is-open="reject_confirm_model">
        <template #body>
            <div class="flex-grow">
                <div class="flex justify-between ">
                    <p class="text-lg font-medium ">Reject Receipt</p>
                </div>
                <div>
                    <Label :required="true" value="Remark"/>
                    <textarea
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border border-gray-300 rounded-md px-4 py-2 w-full"
                        type="text" v-model="rejectForm.remark"/>
                    <InputError :message="rejectForm.errors.remark"/>
                </div>
            </div>
        </template>
        <template #buttons>
            <div class="flex justify-end">
                <Button @click="reject_confirm_model=false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4">Close
                </Button>
                <Button @click="handleRejectForm" class="mr-2">Submit</Button>
            </div>
        </template>
    </Model>

    <Model :is-open="payment_confirm_model">
        <template #body>

            <div class="flex-grow">
                <div class="flex justify-between ">
                    <p class="text-lg font-medium ">Confirm Payment</p>
                </div>
                <div class="grid  gap-4 grid-cols-2 ">

                    <div>
                        <Label :required="true" value="Payment Date"/>
                        <Input class="w-full" type="date" v-model="emiConfirmForm.paid_at"/>
                        <InputError :message="emiConfirmForm.errors.paid_at"/>
                    </div>
                    <FormMultiselect
                        required
                        label="Payment Mode"
                        :options="payment_modes"
                        track-key="id"
                        label-key="title"
                        return-value="id"
                        v-model="emiConfirmForm.payment_mode_id"
                        :placeholder="'Select payment mode'"
                        :error="emiConfirmForm.errors.payment_mode_id"
                    />

                    <div class="col-span-2">
                        <Label value="Remark"/>
                        <textarea
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border border-gray-300 rounded-md px-4 py-2 w-full"
                            type="text" v-model="emiConfirmForm.remark"/>
                        <InputError :message="emiConfirmForm.errors.remark"/>
                    </div>

                </div>
            </div>

        </template>
        <template #buttons>
            <div class="flex justify-end">
                <Button @click="payment_confirm_model=false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4">Close
                </Button>
                <Button @click="handleEmiConfirmForm" class="mr-2">Submit</Button>
            </div>
        </template>
    </Model>


    <Model :is-open="late_fee_model">
        <template #body>

            <div class="flex-grow space-y-4">
                <div class="flex justify-between ">
                    <p class="text-lg font-medium">Late Fee</p>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div class="w-full">
                        <Label :value="'Amount'"/>
                        <Input :disabled="true" type="number"
                               :value="latePaymentForm.late_fee-latePaymentForm?.discount"
                               class="w-full"/>
                        <InputError :message="latePaymentForm.errors?latePaymentForm.errors.late_fee:''"/>
                    </div>
                    <div class="w-full">
                        <Label :required="true" :value="'Discount'"/>
                        <Input required
                               type="number"
                               v-model="latePaymentForm.discount"
                               class="w-full"/>
                        <InputError :message="latePaymentForm.errors?latePaymentForm.errors.discount:''"/>
                    </div>
                    <div>
                        <Label :required="true" value="Payment Date"/>
                        <Input class="w-full" type="date" v-model="latePaymentForm.paid_at"/>
                        <InputError :message="latePaymentForm.errors.paid_at"/>
                    </div>
                    <div>
                        <FormMultiselect
                            required
                            label="Payment Mode"
                            :options="payment_modes"
                            track-key="id"
                            label-key="title"
                            return-value="id"
                            v-model="latePaymentForm.payment_mode_id"
                            :placeholder="'Select payment mode'"
                            :error="latePaymentForm.errors.payment_mode_id"
                        />
                    </div>
                </div>
                <div class="flex justify-between ">
                    <p class="text-lg font-medium">Update EMI Dates</p>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <Label :required="true" value="End Date"/>
                        <Input class="w-full" type="date" v-model="latePaymentForm.end_date"/>
                        <InputError :message="latePaymentForm.errors.end_date"/>

                    </div>
                    <div>
                        <Label :required="true" value="Due Date"/>
                        <Input class="w-full" type="date" v-model="latePaymentForm.due_date"/>
                        <InputError :message="latePaymentForm.errors.due_date"/>
                    </div>
                </div>
            </div>
        </template>
        <template #buttons>
            <div class="flex justify-end">
                <Button @click="late_fee_model=false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4">Close
                </Button>
                <Button @click="handleLateFeeForm" class="mr-2">Submit</Button>
            </div>
        </template>
    </Model>


    <div style="height: calc(100vh - 190px);" class="overflow-auto -m-6">
        <form @submit.prevent="handleEmiForm" class="p-6">

            <div class="flex justify-between ">
                <p class="text-lg font-medium mb-4">Fees Structure</p>
                <div v-if="!admissionFees.length">
                    <Button type="button" :disabled="tempForm.processing"
                            @click="tempForm.processing?null:handleDefaultEMIStructure()">
                        Copy Course fees
                    </Button>
                </div>
            </div>
            <div class="sticky -top-1 bg-white z-10 pt-4">
                <div class="bg-white border rounded px-4 py-2">
                    <div class="flex justify-between items-center space-x-4 ">
                        <p class="col-span-1">Original Fee: ₹{{ admission.total_fee }}</p>
                        <div class="flex items-center col-span-2">
                            <p class="mr-1">Discount: </p>

                            <div class="w-48" v-if="!(admission?.total_discount || emi_paid_amount)">
                                <Input :disabled="admission?.total_discount"
                                       @change="handleDiscountAmount($event.target.value)"
                                       type="text"
                                       v-model="emiForm.total_discount"/>
                                <InputError :message="emiForm.errors.total_discount"/>
                            </div>
                            <span v-else>₹{{ emiForm.total_discount }}</span>
                        </div>
                    </div>
                    <div class="flex justify-between items-center space-x-4 mt-1">
                        <p class="col-lg-1">Discounted Fee:
                            ₹{{ (admission.total_fee - emiForm.total_discount).toFixed(0) }}</p>

                        <p class="col-span-1">Fee Paid : ₹{{ emi_paid_amount.toFixed(0) }}</p>
                        <p class="col-lg-1">Remaining Fee: ₹{{ emiForm.total_fee.toFixed(0) }}</p>
                    </div>
                </div>
            </div>


            <div class="mt-6 grid  divide-y">
                <div class="grid grid-cols-12 gap-4 relative pt-4 pb-8" v-for="(emi,index) in emiForm.emi" :key="index">
                    <div class="col-span-4">
                        <Label :required="true" value="Title"/>
                        <Input :disabled="emi.status ==='confirmed'" type="text" v-model="emi.title"/>
                        <InputError :message="emiForm.errors[`emi.${index}.title`]"/>
                        <div class="absolute flex space-x-4 pt-1 font-semibold">
                            <p @click="handleLatePaymentModel(emi)"
                               v-if="emi.late_fee && (((emiForm?.emi?.[(index - 1)]?.status??'confirmed') === 'confirmed') && emi.status !== 'confirmed')"
                               class="text-red-600 text-sm cursor-pointer ">
                                Late fee: ₹{{ emi.late_fee }}
                            </p>
                             <p v-else-if="((emiForm?.emi?.[(index - 1)]?.status??'confirmed') === 'confirmed') && emi.status !== 'confirmed'"
                                 @click="handleConfirmPaymentModel(emi)"
                               class="text-blue-600 text-sm cursor-pointer underline">
                                Mark as paid
                            </p>
                            <p @click="handleLateFeeHistoryModel(emi)"
                               v-if="emi?.late_fees?.length"
                               class="text-blue-600 text-sm cursor-pointer underline">
                                Late fee history
                            </p>
                        </div>

                    </div>
                    <div class="col-span-2">
                        <Label :required="true" value="Amount"/>
                        <Input @focusout="emi.amount = parseInt(emi.amount).toFixed(2)"
                               :disabled="emi.status ==='confirmed'"
                               type="text" v-model="emi.amount"/>
                        <InputError :message="emiForm.errors[`emi.${index}.amount`]"/>
                    </div>
                    <div class="col-span-2">
                        <Label :required="true" value="End Date"/>
                        <Input :disabled="emi.status ==='confirmed'" type="date" v-model="emi.end_date"/>
                        <InputError :message="emiForm.errors[`emi.${index}.end_date`]"/>

                    </div>
                    <div class="col-span-2">
                        <Label :required="true" value="Due Date"/>
                        <Input :disabled="emi.status ==='confirmed'" type="date" v-model="emi.due_date"/>
                        <InputError :message="emiForm.errors[`emi.${index}.due_date`]"/>
                    </div>
                    <div class="col-span-2 flex">
                        <div class="pt-[26px] flex items-center gap-2"
                             v-if="emi.status == 'pending' || emi.status == 'rejected'">

                            <svg xmlns="http://www.w3.org/2000/svg" @click="handleConfirmDeleteModel(emi,index)"
                                 class="h-6 w-6 text-red-500 hover:text-red-700 justify-self-center cursor-pointer"
                                 viewBox="0 0 20 20"
                                 fill="currentColor">
                                <path fill-rule="evenodd"
                                      d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                      clip-rule="evenodd"></path>
                            </svg>
                        </div>
                        <div v-if="emi.status == 'confirmed'" class="text-green-600 pt-7">
                            Paid
                        </div>

                        <span
                            v-if="emi.remark"
                            class="relative group cursor-pointer ml-2 mt-7"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 text-indigo-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z"
                                />
                            </svg>

                            <div
                                class="absolute z-20 left-6 top-1/3 -translate-y-1/2 bg-gray-800 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition pointer-events-none whitespace-pre-line min-w-[120px]"
                            >
                                {{ emi.remark }}
                            </div>
                        </span>
                    </div>

                    <div v-if="emi.status == 'in_review'" class="col-span-12 flex items-center gap-2 mt-4">
                        <a v-if="emi.receipt" class="inline-flex items-center px-4 py-2 cursor-pointer
                     bg-gray-800 border border-transparent rounded-md
                      font-semibold text-xs text-white uppercase tracking-widest
                      hover:bg-gray-700 active:bg-gray-900 focus:outline-none
                      focus:border-gray-900 focus:shadow-outline-gray
                      transition ease-in-out duration-150 justify-center text-nowrap"
                           :href="emi.receipt" target="_blank">View receipt</a>
                        <Button type="button" @click="handleDirectConfirm(emi)">Confirm</Button>
                        <Button type="button" class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white"
                                @click="handleRejectModel(emi)">Reject</Button>
                    </div>
                </div>
            </div>
            <div class="flex space-x-2 items-center">
                <Button v-if="final_price > 1" type="button" @click="handleAddEMI">Add EMI</Button>
                <Button v-if="final_price > 1" :disabled="emiForm.processing" type="submit">Save</Button>
                <InputError :message="$page.props.errors.emi" />
                <p class="text-sm text-green-700">
                    {{ emiForm.success_message }}
                </p>
            </div>
        </form>

    </div>
</template>
<script setup>
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import Button from "@/Components/Button.vue";
import Label from "@/Components/Label.vue";
import Input from "@/Components/Input.vue";
import {onMounted, ref} from "vue";
import InputError from "@/Components/InputError.vue";
import Model from "@/Components/Model.vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import Table from "@/Components/Table.vue";
import {inputDateFormat} from "../../../../Utils/Common";

const payment_modes = usePage().props.value.payment_modes;
const admission = usePage().props.value.admission;
const branch = usePage().props.value.branch;
const admissionFees = usePage().props.value.admissionFees;
const emi_paid_amount = usePage().props.value.emi_paid_amount;
const final_price = admission?.total_fee - emi_paid_amount - admission?.total_discount;

// onMounted(() => {
//     if (!admissionFees.length) {
//         // handleAddEMI();
//     }
// });

const item = ref({});
const payment_confirm_model = ref(false);
const reject_confirm_model = ref(false);
const late_fee_model = ref(false);
const late_fee_history_model = ref(false);
const delete_confirm_model = ref(false);
const emiForm = useForm({
    total_fee: final_price,
    total_discount: admission?.total_discount,
    success_message: '',
    emi: [...admissionFees]
});

const emiConfirmForm = useForm({
    status: 'confirmed',
    remark: '',
    paid_at: '',
    payment_mode_id: '',
});

const rejectForm = useForm({
    status: 'rejected',
    remark: '',
});

const confirmForm = useForm({
    status: 'confirmed',
});

const latePaymentForm = useForm({
    status: '',
    admission_id: admission.id,
    amount: 0,
    late_fee: 0,
    remark: '',
    discount: 0,
    end_date: '',
    due_date: '',
    paid_at: inputDateFormat(),
    payment_mode_id: '',
    id: ''
});

const tempForm = useForm({});

const handleAddEMI = () => {
    if (final_price > 1) {
        emiForm.emi.push({
            title: '',
            status: 'pending',
            id: 0,
        });
        handleEMICalculation();
    } else {
        alert('Not pending amount');
    }

}

const handleRemoveEMI = (item, index) => {
    if (item.id) {
        tempForm.post(route('internal.admission.fees.emi.delete', [branch.id, item.id]), {
            preserveState: true,
            preserveScroll: true,
            onSuccess: () => {
                showSuccessMessage('emi deleted successfully');
                handleEMICalculation();
                handleEmiForm();
            },
        });
    }
    emiForm.emi.splice(index, 1);
    handleEMICalculation();
    delete_confirm_model.value = false;
}

const handleEMICalculation = () => {
    const newEmi = emiForm.emi.filter((item) => (item.status === 'pending' || item.status === 'rejected'));
    const newEmiConfirm = emiForm.emi.filter((item) => (item.status === 'confirmed' || item.status === 'in_review'));
    const _emi_count = newEmi.length;
    const _per_emi_amount = (emiForm.total_fee / _emi_count).toFixed(2);
    newEmi.map((item, index) => {
        item.amount = _per_emi_amount;
        item.title = `EMI ${newEmiConfirm.length + index + 1}`;
    })
}

const handleEmiForm = () => {
    emiForm.post(route('internal.admission.fees.emi', [branch.id, admission.id]), {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => showSuccessMessage()
    });
}

const showSuccessMessage = (message = 'EMI Fee structure update successfully') => {
    emiForm.success_message = message;
    setTimeout(() => {
        emiForm.success_message = '';
    }, 3000);
}

const handleDiscountAmount = (value = 0) => {
    if (value < final_price) {
        emiForm.total_fee = final_price - value;
    } else {
        emiForm.total_fee = 0;
        emiForm.total_discount = final_price;
    }
    handleEMICalculation();

}

const handleConfirmPaymentModel = (emi) => {
    payment_confirm_model.value = true;
    item.value = emi;
}

const handleDirectConfirm = (emi) => {
    confirmForm.post(route('internal.admission.fees.emi.status', [branch.id, admission.id, emi.id]), {
        preserveState: false,
        preserveScroll: true,
        onSuccess: (res) => {
            showSuccessMessage('EMI status update successfully');
            emiForm.emi = [...res.props?.admissionFees ?? []];
        }
    });
}

const handleRejectModel = (emi) => {
    reject_confirm_model.value = true;
    item.value = emi;
    rejectForm.remark = '';
}

const handleConfirmDeleteModel = (emi, index) => {
    if (emi.id) {
        delete_confirm_model.value = true;
        item.value = emi;
        item.value.index = index;
    } else {
        handleRemoveEMI(item.value, index);
    }

}

const handleLatePaymentModel = (emi) => {
    late_fee_model.value = true;
    item.value = emi;
    latePaymentForm.amount = emi.late_fee;
    latePaymentForm.late_fee = emi.late_fee;
    latePaymentForm.end_date = emi.end_date;
    latePaymentForm.due_date = emi.due_date;
    latePaymentForm.id = emi.id;
}

const handleLateFeeHistoryModel = (emi) => {
    late_fee_history_model.value = true;
    item.value = emi;
}

const handleEmiConfirmForm = () => {
    emiConfirmForm.post(route('internal.admission.fees.emi.status', [branch.id, admission.id, item.value.id]), {
        preserveState: false,
        preserveScroll: true,
        onSuccess: (res) => {
            payment_confirm_model.value = false;
            showSuccessMessage('EMI status update successfully');
            emiForm.emi = [...res.props?.admissionFees ?? []];
        }
    });
}

const handleRejectForm = () => {
    rejectForm.post(route('internal.admission.fees.emi.status', [branch.id, admission.id, item.value.id]), {
        preserveState: false,
        preserveScroll: true,
        onSuccess: (res) => {
            reject_confirm_model.value = false;
            showSuccessMessage('EMI status update successfully');
            emiForm.emi = [...res.props?.admissionFees ?? []];
        }
    });
}

const handleLateFeeForm = () => {
    const _form_end_date = new Date(latePaymentForm.end_date);
    const _form_due_date = new Date(latePaymentForm.due_date);

    const _end_date = new Date(item.value.end_date);
    const _due_date = new Date(item.value.due_date);

    if ((_form_due_date <= _due_date) || (_form_due_date <= _end_date)) {
        alert('Please update new future dates for EMI.');
        return false;
    }
    latePaymentForm.post(route('internal.admission.late.fees', [branch.id, admission.id, latePaymentForm.id]), {
        onSuccess: () => {
            late_fee_model.value = false;
            showSuccessMessage('Late payment pay successful.');
            window.location.reload();
        }
    });
}

const handleDefaultEMIStructure = () => {
    tempForm.post(route('internal.admission.emi.structure', [branch.id, admission.id]), {
        preserveState: false,
        preserveScroll: true,
        onSuccess: () => {
            showSuccessMessage('EMI Fee structure generated successfully');
        }
    });
}
</script>
